import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';

const ErrorAlert = ({ error, onDismiss }) => {
  if (!error) {
    return null;
  }

  const alertProps = {
    color: 'danger',
    className: 'mb-3',
  };

  if (onDismiss) {
    alertProps.toggle = onDismiss;
  }

  return <Alert {...alertProps}>{error}</Alert>;
};

ErrorAlert.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null, false])]),
  onDismiss: PropTypes.func,
};

export default ErrorAlert;
